import { render, staticRenderFns } from "./e10.vue?vue&type=template&id=61a13dcb&scoped=true&"
import script from "./e10.vue?vue&type=script&lang=js&"
export * from "./e10.vue?vue&type=script&lang=js&"
import style0 from "./e10.vue?vue&type=style&index=0&id=61a13dcb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a13dcb",
  null
  
)

export default component.exports